function checkDefined(object: any) {
  return typeof object !== 'undefined';
}

export default checkDefined;
